import React, { Component } from 'react';
import { X } from 'lucide-react';
import ReactGA from "react-ga4";
import SignupPrompt from './SignupPrompt';
import config from "../utils/config.js";
import ReactMarkdown from "react-markdown"
class ConsumerChat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: this.props.initialMessage || "",
      messages: [{
        role: "assistant", 
        content: "Hey there!"
      },
      {
        role: "assistant", 
        content: "Want to add or replace an ingredient in this recipe? Just ask me!"
      }],
      loading: false,
      input: "",
      ingredientUpdated: false,
      oldrecipe: this.props.recipe,
      showSignupPrompt: false
    }
  }

  componentDidMount() {
    console.log("Recipe:", this.props.recipe);
    if (this.props.initialMessage) {
      this.sendMessage(this.props.initialMessage);

      ReactGA.event({
        category: 'Template Prompt clicked',
        action: 'Button Click',
        label: this.props.initialMessage,
        value: localStorage.getItem("userId") ? localStorage.getItem("userId") : "anonymous",
      });
    }
  }

  async sendMessage(message) {
    this.setState({
      loading: true,
      input: ""
    });

    try {
      // First send the chat message
      const response = await fetch(`${config.API_SERVER_URL}/api/v1/chat/recipe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('userToken')}`
        },
        body: JSON.stringify({
          message: message,
          recipe: this.props.recipe,
          messages: this.state.messages
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      if(response.status == 402) {
        this.setState({
          showSignupPrompt: true
        })
      }

      const data = await response.json();
      
      // Update messages with the response
      this.setState(prevState => ({
        messages: data.history.filter(message => {
          // Skip messages that contain special keywords
          const messageText = message.text || '';
          return !(
            messageText.includes("ingredient:") || 
            messageText.includes("cookware:") || 
            messageText.includes("ingredients:") || 
            messageText.includes("cookwares:") || 
            messageText.includes("step:") || 
            messageText.includes("steps:") || 
            messageText.includes("new:") || 
            messageText.includes("old:")
          );
        })
      }));

      // Check if response contains recipe change indicators
      const responseText = data.message.toLowerCase();
      if (responseText.includes("ingredient:") || 
          responseText.includes("cookware:") || 
          responseText.includes("ingredients:") || 
          responseText.includes("cookwares:") || 
          responseText.includes("step:") || 
          responseText.includes("steps:") || 
          responseText.includes("new:") || 
          responseText.includes("old:")) {
        
        // Add quality test message
        this.setState(prevState => ({
          messages: [
            ...prevState.messages,
            { 
              role: "assistant", 
              content: "Quality check started... I'll update the ingredients and instructions if this **change request passes** our food quality test." 
            }
          ]
        }));

        // Get recipe update
        const updateResponse = await fetch(`${config.API_SERVER_URL}/api/v1/chat/recipe/update`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('userToken')}`
          },
          body: JSON.stringify({
            message: message,
            recipe: this.props.recipe,
            messages: this.state.messages
          })
        });

        if (!updateResponse.ok) {
          throw new Error(`HTTP error! status: ${updateResponse.status}`);
        }

        const updateData = await updateResponse.json();
        
        // Update recipe in parent component
        this.props.updateNewReceipe(updateData.recipe);

        // Add completion message
        this.setState(prevState => ({
          messages: [
            ...prevState.messages,
            { role: "assistant", content: "Done!" }
          ]
        }));
      }

      // Update attempt count
      if (sessionStorage.getItem("attemps")) {
        sessionStorage.setItem("attemps", Number(sessionStorage.getItem("attemps")) + 1);
      } else {
        sessionStorage.setItem("attemps", 1);
      }

    } catch (error) {
      console.error('Error:', error);
      this.setState(prevState => ({
        messages: [...prevState.messages, { 
          role: "assistant", 
          content: "Sorry, You need to sign in and have a active subscription to use this feature." 
        }]
        
      }));
      this.setState({
        showSignupPrompt: true
      })
    } finally {
      this.setState({
        loading: false,
        message: '',
        input: ''
      });
    }
  }

  render() {
    function setViewportHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);

    return (
      <div style={{
        position: "sticky",
        top: "8rem",
        overflow: "scroll"
      }}>
        <div className="flex flex-col rounded-3xl lg:!h-[80vh]" style={{
          height: `calc(var(--vh, 1vh) * 100)`
        }}>
          <div className="flex justify-between p-4 rounded-t-2xl text-white font-bold text-center text-xl" style={{
            background: "linear-gradient(to right,  #0c5212 0%,  #3ba958 35%)"
          }}>
            <span>Chat with our Sous Chef</span>
            <span className='lg:hidden' onClick={this.props.onClose}><X /></span>
          </div>
          <div className="flex-grow overflow-y-scroll lg:mb-0 w-screen lg:w-full bg-white">
            <div className="flex flex-col space-y-2 p-4">
              {this.state.messages.map((message, index) => (
                <div key={index} className={`flex items-center ${message.role === 'user' ? 'self-end' : 'self-start'}`}>
                  <div className={`rounded-[10px] px-4 py-2 ${message.role === 'user' ? 'bg-green-600 text-white rounded-br-none' : 'bg-gray-300 rounded-bl-none'}`}
                    style={{
                      boxShadow: "0 2px 2px rgba(0,0,0,0.2)",
                      wordWrap: "break-word",
                      overflowWrap: "break-word"
                    }}>
                    <ReactMarkdown>{message.content}</ReactMarkdown>                    
                    
                  </div>
                </div>
              ))}
              {this.state.loading && (
                <div className="mt-6">
                  <div className="typing">
                    <span className="circle scaling"></span>
                    <span className="circle scaling"></span>
                    <span className="circle scaling"></span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center p-3 bg-white" style={{
            boxShadow: "0 -2px 2px rgba(0,0,0,0.1)",
            bottom: "0%",
            maxHeight: "60px",
            overflowY: "auto"
          }}>
            {this.state.loading ? 
              <div className="flex-grow outline-none opacity-55 text-gray-400" style={{
                border: 'none',
                resize: 'none',
                outline: 'none',
                width: '100%',
                minHeight: '50px',
                padding: '10px 20px',
                borderRadius: '25px',
              }}>Processing...</div> 
              : 
              <textarea
                type="text"
                id='input-field'
                value={this.state.input}
                placeholder='Type your message...'
                wrap='soft'
                style={{
                  border: 'none',
                  resize: 'none',
                  outline: 'none',
                  width: '100%',
                  minHeight: '50px',
                  padding: '10px 20px',
                  borderRadius: '25px',
                }}
                onChange={(e) => this.setState({ message: e.target.value, input: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if (e.target.value == "") return;
                    this.sendMessage(e.target.value);
                  }
                }}
                className="flex-grow outline-none"
              />
            }
            <button
              disabled={this.state.loading || this.state.input == ""}
              className="ml-4 bg-green-600 text-white rounded-full p-2"
              style={{
                width: "35px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              onClick={() => {
                if (this.state.input) {
                  this.sendMessage(this.state.input);
                }
              }}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-6 h-6">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
        {this.state.showSignupPrompt && (
          <SignupPrompt onClose={() => this.setState({ showSignupPrompt: false })} />
        )}
      </div>
    );
  }
}

export default ConsumerChat; 